<template lang="html">
    <li :class="color">
        <router-link
            v-if="type == 'player'"
            :to="{ name: 'playerLesson', params: { id: lesson.id } }"
        >
            <span class="date">
                {{ $date(lesson.date).format("DD MMM YYYY") }}

                {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }} -
                {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                <span v-if="lesson.cancelled_at" class="cancelled">Cancelled</span>
                <!--<span class="upcoming" v-if="isUpcoming">Upcoming</span>-->
            </span>
            <lesson-star :lesson="lesson" />
            <img class="arrow" src="@/assets/arrow-right-white.svg" />
        </router-link>

        <router-link
            :style="isWhite"
            v-else
            :to="{ name: 'proPlayerLesson', params: { id: lesson.player_id, lesson: lesson.id } }"
        >
            <span class="date">
                {{ $date(lesson.date).format("DD MMM YYYY") }}

                <template v-if="lesson.start != lesson.end">
                    {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }} -
                    {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                </template>

                <span v-if="lesson.cancelled_at" class="cancelled">Cancelled</span>
                <lesson-star :lesson="lesson" />
            </span>
            <img class="arrow" src="@/assets/arrow-right-white.svg" />
        </router-link>
    </li>
</template>

<script>
import LessonStar from "@/components/Player/Lessons/lesson-star";
export default {
    name: "lesson-list-item",
    props: {
        white: {
            required: false,
            type: Boolean,
        },
        color: {
            type: String,
            default: "",
            required: false,
        },
        lesson: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            default: "player",
            required: false,
        },
    },
    components: { LessonStar },
    computed: {
        isWhite() {
            if (this.white) {
                return { background: "white" };
            }
            return false;
        },
        isUpcoming() {
            var today = this.$date(new Date());

            if (today.isBefore(this.$date(this.lesson.time))) {
                return true;
            }

            return false;
        },
    },
};
</script>

<style lang="scss" scoped>
.lessonList {
    li {
        margin-bottom: 10px;
        position: relative;
        font-weight: 200;
        height: 52px;
        position: relative;
        &.white {
            a {
                background: white;
            }
        }
        .arrow {
            margin-top: -2px;
            pointer-events: none;
        }
        a {
            display: block;
            text-decoration: none;
            color: $green_0;
            background: $grey;
            padding: 17px;
            border-radius: 12px;

            .upcoming,
            .cancelled {
                padding: 5px 8px;
                background: $green_1;
                border-radius: 4px;
                display: inline-block;
                margin-left: 10px;
                color: white;
                font-size: 0.8rem;
            }
            .cancelled {
                background: $red;
            }
            .star {
                position: absolute;
                right: 35px;
                top: 15px;
                appearance: none;
                background: none;
                border: 0px;
                &:focus {
                    outline: 0px;
                }
            }
            .icon {
                position: absolute;
                right: 15px;
                top: 13px;
                width: 18px;
            }
        }
    }
}
</style>
